module.exports = __webpack_public_path__ + "static/media/a18.54d88ec6.pdf";